import * as React from 'react'
import * as Styles from './floatCoupon.style'
import { CountDown } from '@/components/CountDown/CountDown'
import { HttpServer } from '@/services/server'
import globalBus from '@/services/Bus'
import { reportViewEvent, reportClickEvent } from '@weike/operation-report'

interface TimeObjType {
    hh: string,
    mm: string,
    ss: string
}

const TIMEOUT_HOURS = 24 // 过期时间
// const TIMEOUT_HOURS_STEP_TWO = 48
let COUPON_NUM = 51

interface FloatCouponState {
    useStatus: number
    deadline?: number | null
    price: number
    init: boolean
    inviter_id: number
    isLessThanSetTime: boolean
    isShow: boolean
    isChange: boolean
    isInMiddleStep: boolean
    abtest: boolean
    url: string
}

export function GetCountTime(props: {time: number, timeout: () => any, isChange: boolean}) {
    const changeTime = props.time.toString()
    const retTime: TimeObjType = CountDown(changeTime)
    const [retTimeStr, setRetTimeStr] = React.useState<string>('00:00:00')

    React.useEffect(() => {
        if (!props.isChange) {
            let renderTime = ''
            if (retTime && Object.keys(retTime).length > 0) {
                for (const [key, value] of Object.entries(retTime)) {
                    renderTime += value + ':'
                }
                setRetTimeStr(renderTime.substring(0, renderTime.length - 1))
                if (retTime !== null && retTimeStr === '00:00:01') {
                    props.timeout()
                }
            }
        }
    }, [retTime])

    return (
        <span>{retTimeStr}</span>
    )
}

export default class FloatCoupon extends React.PureComponent <{}, FloatCouponState> {
    constructor(props: {}) {
        super(props)
        this.state = {
            isShow: false,
            useStatus: 0,
            deadline: 0,
            price: 0,
            inviter_id: 0,
            init: false,
            isLessThanSetTime: false,
            isChange: false,
            isInMiddleStep: false, // 这个逻辑是大于24小时小于48小时
            abtest: false,
            url: ''
        }
    }
    public async componentDidMount() {
            let CouponURL: string
            let CATEGORY: string
            try {
                const { data: { data } } = await HttpServer.getCouponConfig()
                // tslint:disable-next-line:quotemark
                console.log( "data", data.category)
                if (data.coupon_id) {
                    COUPON_NUM = data.coupon_id
                }

                if (data.category) {
                    CATEGORY = data.category
                }

                if (data.home_url) {
                    CouponURL = data.home_url
                }

                if (data.abtest) {
                    this.setState({
                        abtest: true
                    })
                }

             } catch (error) {
                 console.log('err: getCouponConfig', error)
             }

            const params = {
                bag_id: COUPON_NUM,
                category: CATEGORY
            }

            HttpServer.getFloatCoupon(params).then((res) => {
                if (res.status === 200) {
                    this.setState({
                        useStatus: res.data.code,
                        deadline: res.data.data.deadline,
                        price: res.data.data.price,
                        isShow: (res.data.code === 3 || res.data.code === 2 || res.data.code === -1) ? false : true,
                        inviter_id: res.data.data.inviter_id,
                        isInMiddleStep: false,
                        url: CouponURL,
                        init: true
                    }, () => {
                        if (this.state.isShow) {
                            this.sendReport('show_top_coupon')
                            globalBus.emit({isShowTopCouponTips: 'true'})
                        }
                        const timeRemaining = parseFloat((Number(this.state.deadline) * 1000 - new Date().getTime()).toString())
                        const hours = Math.floor((timeRemaining / (3600 * 1000)))
                        if (hours <= TIMEOUT_HOURS) {
                            this.setState({
                                isLessThanSetTime: true
                            })
                        }

                        if (hours > TIMEOUT_HOURS) { // 大于24小时 小于48小时
                            this.setState({
                                isInMiddleStep: true
                            })
                        }

                    })
                }
            })
    }

    public sendReport(evt: 'show_top_coupon_click' | 'show_top_coupon') {
        if (evt === 'show_top_coupon') {
            reportViewEvent('top_advertisement', {object_type: 'coupon_bag', object_id: COUPON_NUM})
        } else {
            reportClickEvent('top_advertisement', {object_type: 'coupon_bag', object_id: COUPON_NUM})
        }
    }

    public getLink = () => {
        const { url } = this.state
        this.sendReport('show_top_coupon_click')
        setTimeout(() => {
            window.location.assign(url)
        }, 150)
    }

    public CountDownTimeout  = () =>  {
        if (!this.state.isChange) {
            this.setState({isShow: false, isChange: true})
            globalBus.emit({isShowTopCouponTips: 'false'})
        }
    }
    // code 为 3，就是用完了
    // code 为 2，是已经过期

    // code 为 1，是未领取
    // code 为 0  领取了还没用
    public render() {
        if (!this.state.init || !this.state.isShow) {
            return null
        }

        return (
            <div>
                {/* 倒计时 过期 */}
                {this.state.useStatus === 0 && this.state.isLessThanSetTime && this.state.deadline &&
                <div className={Styles.FloatCoupon} onClick={this.getLink}>
                        <div className={Styles.FloatCouponArea}>
                            <div className={Styles.FloatCouponAreaLeftArea}>
                                <img className={Styles.FloatCouponAreaImg} src="https://static-1253442168.image.myqcloud.com/picture/12209467_45def5ca06c6096939c6aa7acb4d6545.jpg" alt="coupon"/>
                                <div className={Styles.sampleText}>你有<span className={Styles.redText}>{this.state.price / 100}</span>元红包
                                <span className={Styles.CountDownWrap}>
                                        <GetCountTime
                                            time={this.state.deadline}
                                            timeout={this.CountDownTimeout}
                                            isChange={this.state.isChange}
                                        />
                                    </span>后过期
                                </div>
                            </div>

                            <div className={Styles.FloatCouponAreaRightArea}>
                                <p>查看详情</p>
                                <img src="https://static-1253442168.image.myqcloud.com/picture/12209467_fcb901f5af3ea9440696ef18f209e3af.jpg" alt=""/>
                            </div>
                        </div>
                    </div>}

                    {/* 未领取 */}
                    {this.state.useStatus === 1 &&
                        <div className={Styles.FloatCoupon} onClick={this.getLink}>
                            <div className={Styles.FloatCouponArea}>
                                <div className={Styles.FloatCouponAreaLeftArea}>
                                    <img className={Styles.FloatCouponAreaImg} src="https://static-1253442168.image.myqcloud.com/picture/12209467_45def5ca06c6096939c6aa7acb4d6545.jpg" alt="coupon"/>
                                    <p className={Styles.sampleText}>你有<span className={Styles.redText}>{this.state.price / 100}</span>元红包未领取，7天后过期</p>
                                </div>

                                <div className={Styles.FloatCouponAreaRightArea}>
                                    <p>立即领取</p>
                                    <img src="https://static-1253442168.image.myqcloud.com/picture/12209467_fcb901f5af3ea9440696ef18f209e3af.jpg" alt=""/>
                                </div>
                            </div>
                        </div>}

                    {/* 即将过期 */}
                    {this.state.useStatus === 0 && this.state.isInMiddleStep &&
                        <div className={Styles.FloatCoupon} onClick={this.getLink}>
                            <div className={Styles.FloatCouponArea}>
                                <div className={Styles.FloatCouponAreaLeftArea}>
                                    <img className={Styles.FloatCouponAreaImg} src="https://static-1253442168.image.myqcloud.com/picture/12209467_45def5ca06c6096939c6aa7acb4d6545.jpg" alt="coupon"/>
                                    <p className={Styles.sampleText}>你有<span className={Styles.redText}>{this.state.price / 100}</span>元红包即将过期</p>
                                </div>

                                <div className={Styles.FloatCouponAreaRightArea}>
                                    <p>查看详情</p>
                                    <img src="https://static-1253442168.image.myqcloud.com/picture/12209467_fcb901f5af3ea9440696ef18f209e3af.jpg" alt=""/>
                                </div>
                            </div>
                    </div>}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/plugins/coupon/floatCoupon.tsx